import { connect } from 'react-redux'
import PerformanceList from '../../components/performance/PerformanceList/PerformanceList'
import * as groupActions from '../../actions/group'
import * as actions from '../../actions/performance'
import { rate } from '../../actions/lk'

const mapStateToProps = ({ group: { years, currentEdYearId }, performance, lk, auth }) => ({
  yearsList: years,
  progress: performance.progress,
  isLoading: performance.isLoading,
  rateList: lk.rateList,
  mid: auth.mid,
  termsList: performance.terms,
  initialValues: {
    educationYear: currentEdYearId,
  },
  rateExam: performance.rateExam
})

const mapDispatchToProps = dispatch => ({
  fetchYears: () => dispatch(groupActions.schoolYear()),
  fetchPerfList: (yearId, type) => dispatch(actions.list(yearId, type)),
  fetchTerms: yearId => dispatch(actions.terms(yearId)),
  fetchRate: () => dispatch(rate()),
  getMarksList: (mid, year, period) => dispatch(actions.getMarksList(mid, year, period))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceList)
